import React from "react";
import mapsImage from "../assets/maps.jpg";

export default function Maps() {
  return (
    <>
      <div className="container-content" style={{ padding: "40px 10px" }}>
        <p
          className="playball-font"
          style={{ fontSize: 23, color: "black", margin: "10px 0px 5px" }}
        >
          Peta Lokasi
        </p>
        <div
          style={{
            height: 3,
            width: 100,
            backgroundColor: "#cc9933",
            marginTop: 3,
            marginBottom: 15,
          }}
        />
        <p
          className="garamond-font"
          style={{
            fontSize: 18,
            color: "black",
            fontWeight: "bold",
            marginTop: 5,
          }}
        >
          Golden City Ballroom
        </p>
        <p
          className="garamond-font"
          style={{
            fontSize: 15,
            color: "black",
            margin: "5px 20px 0px",
          }}
        >
          Jl. KH Abdul Wahab Siamin Surabaya No.8, RW.2, Dukuh Pakis,
          Dukuhpakis, <br /> Kota Surabaya, Jawa Timur 60225
        </p>
        <div
          style={{
            width: "100%",
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          <img
            src={mapsImage}
            objectFit="contain"
            width="100%"
            // height="100%"
            style={{ borderRadius: 20 }}
          />
        </div>
        <a
          style={{ textDecoration: "none" }}
          target="_blank"
          href="https://www.google.com/maps/place/Ballroom+Golden+City/@-7.2921784,112.7056148,18z/data=!3m1!4b1!4m5!3m4!1s0x2dd7fc73ab6c5ceb:0x12b6abc6376e4d9a!8m2!3d-7.2921833!4d112.7067176"
        >
          <button className="button-18">
            <i
              className="fas fa-map-marker-alt"
              style={{ color: "red", fontSize: 22, marginRight: 10 }}
            />
            <p>Buka di GMAPS</p>
          </button>
        </a>
      </div>
    </>
  );
}
